import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import intl from 'react-intl-universal';
import { Menu, Dropdown, Row, Col, Tooltip, Modal, Button } from 'antd';
import { /*isPdfOnlineDomain,*/ prop, windowActionFn /*getPrivacyPolicyUrl,getTermsOfServiceUrl*/ } from 'Utils/utils';
// import { ROUTE_PATH_SURVEY_RESULT} from 'Api/constants';
import { CheckOutlined } from '@ant-design/icons';
import utils from '@foxit/utils';
const { SubMenu } = Menu;
import {
  ABOUT_FOXIT_SOFTWARE,
  SUBSCRIBE,
  MY_ACCOUNT,
  SHARE_BUTTON,
  // TO_ADMIN_CONSOLE,
  /*PRIVACY_POLICY,
  TERM_OF_SERVICE*/
} from 'Components/viewer/ui/constants/user.more.constants';
import { OPEN_FILE } from 'Components/viewer/ui/constants/other.constants';
import { CREATE_BLANK_PDF } from 'Components/viewer/ui/constants/convert.constants';
import { HOME_PRINT } from 'Components/viewer/ui/constants/home.constants';
import { SAVE_TO_LOCAL } from 'Components/viewer/ui/constants/savefile.constants';
import { store } from 'Store/store.index';
// import userIncon from '@/assets/Collaboration/sign-in.svg';
// import userSignUpcon from '@/assets/Collaboration/sign-up.svg';
//import switchLangIcon from '@/assets/user/switch-lang.svg';
import { COLLABORATION_HEADER, COMMON_HEADER } from '@/constants/index';
import '../header/header.scss';
import '../header/HeaderContainer.scss';
import Meeting from './meeting';
import DownloadApp from './downloadApp';
import ShareBtn from './share';
import ShareCollaborationbtn from './shareCollaborationbtn';
// 共享协作
import CollaborationHeader from '../header/CollaborationHeader';
// import { COLLECT_NPS_SURVEY} from 'Constants/app.constant';
import { fileController } from '@/components/viewer/Controllers/index';
// import DocumentNameHeader from '../header/DocumentNameHeader';
// import NotificationPopover from '../header/NotificationPopover'
import { PRINT /*EXIT, PRIVACY_POLICY, TERM_OF_SERVICE */ } from '../viewer/ui/constants/event.constants.share';
import { isMacSsoNoIos } from 'Utils/device';
import { isSafari } from 'Utils/browser-info';
// import { user } from '@/__mock__/users/user.json';

@inject('appStore', 'userStore', 'homePageStore', 'accountStore', 'historyStore', 'userNewStore', 'loginNewStore')
@observer
class newHeader extends Component {
  constructor(props) {
    super(props);
    this.onLoginIn = this.onLoginIn.bind(this);
    this.onSignUp = this.onSignUp.bind(this);
    this.onLoginOut = this.onLoginOut.bind(this);
    this.onRegister = this.onRegister.bind(this);
    this.onLogoClick = this.onLogoClick.bind(this);
    this.showUserMenu = this.showUserMenu.bind(this);
    this.onChangeLang = this.onChangeLang.bind(this);
    this.onClickContactUs = this.onClickContactUs.bind(this);
    this.onSubscribe = this.onSubscribe.bind(this);
    this.onClickMyAccount = this.onClickMyAccount.bind(this);
    this.state = {
      userBgColorList: ['#ba91ff', '#68AFFF', '#EF80DB', '#FFA800', '#75D060', '#48D3D5', '#E99570', '#758395', '#9DB4E2'],
      isShowNoPdfModal: false,
      isShowNoFunction: false,
      isProtectedView: localStorage.getItem('SECURITY_PROTECTED_VIEW') === 'all' ? true : false, // 共享协调功能
    };
  }
  componentDidMount() {
    store.appStore.getAppLogoAsync();
    const { headerType } = store.appStore;
    if (headerType === COMMON_HEADER) {
      window.pdfui.eventEmitter.on('isProtectedView', (val) => {
        this.setState({
          isProtectedView: val,
        });
      });
    }
  }
  getBgIndex = (userId) => {
    const length = this.state.userBgColorList.length;
    if (!userId) return length - 1;
    const key = userId[userId.length - 1];
    var s = 'a b c d e f g h i j k l m n o p q r s t u v w x y z 0 1 2 3 4 5 6 7 8 9';
    var sArray = s.split(' ');
    let keyIndex = 0;
    sArray.forEach((item, index) => {
      if (key === item) keyIndex = index % length;
    });
    return keyIndex;
  };
  onLoginIn() {
    // store.userNewStore.getUserNew()
    store.loginNewStore.login();
    // store.userStore.loginIn();
  }
  onChangeLang(lang) {
    store.appStore.changeLanguage(lang);
  }
  onClickContactUs() {
    store.userStore.doSendGAEventByUser({ eventKey: ABOUT_FOXIT_SOFTWARE, label: 'upper_right_area' });
    let url =
      'https://globe-map.foxitservice.com/go.php?title=company-about&product=Foxit%20PhantomPDF%20Online&&edition=&version=&utm_source=phantomonline&language=';
    url += store.appStore.lng.full;
    windowActionFn(window, 'open', [url]);
  }
  onSignUp() {
    store.userNewStore.getUserNew();
    // store.userStore.signUp(false);
  }
  onSubscribe() {
    store.userStore.setSubscribeVisible(true);
    if (store.appStore.isCollaborationMode()) {
      store.userStore.doSendGAEvent({ eventKey: SUBSCRIBE, label: 'review_mode_upper_right_area' });
    } else {
      store.userStore.doSendGAEventByUser({ eventKey: SUBSCRIBE, label: 'upper_right_area' });
    }
  }
  onClickMyAccount() {
    //store.userStore.setAcountVisibe(true);
    store.userStore.doGoToAccount();
    if (store.appStore.isCollaborationMode()) {
      store.userStore.doSendGAEvent({ eventKey: MY_ACCOUNT, label: 'review_mode_upper_right_area' });
    } else {
      store.userStore.doSendGAEventByUser({ eventKey: MY_ACCOUNT, label: 'upper_right_area' });
    }
  }
  onRegister() {}
  onLoginOut() {
    store.loginNewStore.signOut();
    // window.onShowToSaveBeforeOpen((isToSave) => {
    //   if(!isToSave) {
    //     store.collaborationStore.exitCollaboration(true)
    //     store.userStore.loginOut(false);
    //   }
    // })
  }
  onLogoClick() {
    store.userStore.doGoToHomePage();
  }
  onFeedbackNav = () => {
    if (!store.userNewStore.isLogin) {
      store.loginNewStore.login();
      // store.userStore.signUp()
    } else {
      const feedbackWin = windowActionFn(window, 'open', ['/feedback']);

      function onHandleWindowMessage(event) {
        const action = event.data.action;

        if (action === 'close') {
          feedbackWin.close();

          window.removeEventListener('message', onHandleWindowMessage, false);
        }
      }
      window.addEventListener('message', onHandleWindowMessage, false);
    }
  };
  toShareListFunc = () => {
    window.history.pushState('', '', '/');
    if (window.pdfui) window.pdfui.pdfViewer.close();
    store.appStore.updateShowShareErrorMask(false);
    store.appStore.setHomeHeader();
    store.appStore.updateShowHomeStart(true);
    store.homePageStore.setHomeSideTabActive('share-list');
  };
  toShareList = () => {
    if (store.appStore.docModified) {
      const { onShowToSaveBeforeOpen } = store.appStore;
      onShowToSaveBeforeOpen((isToSave) => {
        !isToSave && this.toShareListFunc();
      });
    } else {
      this.toShareListFunc();
    }
  };
  isSurveyList = () => {
    let pathname = prop(location, 'pathname');
    return pathname === '/survey-list';
  };
  isHideUserElements = () => {
    // let pathname = prop(location, 'pathname');
    // switch (pathname) {
    //   // case ROUTE_PATH_EMAIL_MANAGE:
    //   case ROUTE_PATH_SURVEY_RESULT: {
    //     return true;
    //   }
    // }
    return false;
  };
  navToWithBlank = (href, butName) => {
    if (store.appStore.isCollaborationMode()) {
      store.userStore.doSendGAEvent({ eventKey: butName, label: 'review_mode_upper_right_area' });
    } else {
      store.userStore.doSendGAEventByUser({ eventKey: butName, label: 'upper_right_area' });
    }
    windowActionFn(window, 'open', [href]);
  };
  // 头部登录及注册的弹窗
  showLoginMenu() {
    // const { isOnPremiseDeployMode } = store.appStore;
    // const menu = (
    //   <Menu className="user-dropdown-menu-wrapper">
    //     <Menu.Item style={{ cursor: 'default' }}>
    //       <span className={'can_click'} onClick={this.onLoginIn}>
    //         {/* <Avatar size="small" shape="square" src={userIncon}></Avatar>
    //         <span>{intl.get('user.signIn')}</span> */}
    //       </span>
    //     </Menu.Item>
    //     {/* {!isOnPremiseDeployMode && (
    //       <Menu.Item>
    //         <span className={'can_click'} onClick={this.onSignUp}>
    //           <Avatar size="small" shape="square" src={userSignUpcon}></Avatar>
    //           <span>{intl.get('user.signUp')}</span>
    //         </span>
    //       </Menu.Item>
    //     )} */}
    //   </Menu>
    // );
    return (
      <span className={'can_click'} onClick={this.onLoginIn}>
        登录
      </span>
    );
  }
  // ! 用户信息弹窗
  showUserMenu(userInfo) {
    if (!userInfo) {
      return null;
    }
    // let pheeAdminUrl;
    // if (isAdmin) {
    //   pheeAdminUrl = store.appStore.pheeAdminUrl;
    // }
    const { userData } = store.userNewStore;
    // const {userName, userAcount} = store.userStore;
    let name = userData.nickname;
    let payOrigin = isMacSsoNoIos || isSafari ? 'edit.foxitcloud.cn/pay/edit/' : 'www.foxitcloud.cn/pay/edit/';
    let payUrl = `https://${payOrigin}?from=startpage${location.search.trim().slice(1) && '&'}${location.search.trim().slice(1)}`;
    if (window.location.search.includes('from=pdf365/?refer=bd')) {
      payUrl = `https://www.foxitcloud.cn/pay/edit/baidu365/${location.search.trim().slice(1) && '?'}${location.search.trim().slice(1)}`;
    }
    // let tel = userData.tel;
    // let isSurveyList = this.isSurveyList();
    // let privacyPolicyUrl = getPrivacyPolicyUrl();
    // let termsOfServiceUrl = getTermsOfServiceUrl();
    const menu = (
      <Menu className="user-dropdown-menu-wrapper fw_user-dropdown-menu">
        <Menu.Item style={{ cursor: 'default' }} className="fw_menu-user-box fw_menu-user-flex">
          <div className={`fw_user-dropdown-menu-new-icon ${userData && userData.identity === 'vip' ? 'fw_user-dropdown-menu-new-icon-vip' : ''}`}>
            {userData && userData.figure ? (
              <div className="icon-btn new_user_icon">
                <img src={userData.figure} alt="头像" className="fw_user-pigure-new" />
              </div>
            ) : (
              <i className="icon-btn new_user_icon" />
            )}
          </div>
          <div className="fwNameBox">
            <Tooltip placement="bottomRight" title={name}>
              <span className="nameBox">{name}</span>
            </Tooltip>
            <p className="userIdText">账户ID：{userData.userId}</p>
          </div>
        </Menu.Item>
        <Menu.Divider className="dropdown-menu-divider" />
        <Menu.Item
          onClick={() => {
            window.open('https://docs.foxitcloud.cn/');
          }}>
          <i className="icon_user icon_myWord"></i>
          <span>我的文档</span>
        </Menu.Item>
        {/* <Menu.Item onClick={() => {window.open("https://sj.pdf365.cn/")}}>
          <i className="icon_user icon_file-sj"></i>
          <span>文件收集</span>
        </Menu.Item>
        <Menu.Item onClick={() => {window.open("https://huiyi.foxitcloud.cn/web/")}}>
          <i className="icon_user icon_meeting"></i>
          <span>发起会议</span>
        </Menu.Item> */}
        {/* 加入切换账号 */}
        {store.userNewStore.accountList.length > 1 && (
          <SubMenu title="切换账号" icon={<i className="icon_user icon_meeting"></i>}>
            {store.userNewStore.accountList.map((item) => {
              return (
                <Menu.Item
                  key={item.accountId}
                  onClick={() => {
                    store.loginNewStore.switchAccount(item.accountId);
                  }}
                  className={item.accountId == store.userNewStore.userData.userId && 'active'}>
                  <i className="icon_user icon_userItem"></i>
                  <span>{item.nickName}</span>
                  {item.accountId == store.userNewStore.userData.userId && <CheckOutlined />}
                </Menu.Item>
              );
            })}
          </SubMenu>
        )}
        <Menu.Item
          onClick={() => {
            window.open('https://fanyi.pdf365.cn/');
          }}>
          <i className="icon_user icon_translation"></i>
          <span>全文翻译</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            window.open(payUrl);
          }}>
          <i className="icon_user icon_member"></i>
          <span>{userData && userData.identity === 'vip' ? '立即续费' : '开通会员'}</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            window.open('https://edit.foxitcloud.cn/duihuan/');
          }}>
          <i className="icon_user icon_translation"></i>
          <span>兑换会员</span>
        </Menu.Item>
        <Menu.Item onClick={this.toShareList}>
          <i className="icon_user icon_share"></i>
          <span>共享记录</span>
        </Menu.Item>
        <Menu.Divider className="dropdown-menu-divider" />
        <Menu.Item onClick={this.onLoginOut}>
          <i className="icon_user"></i>
          <span>退出账户</span>
        </Menu.Item>
        {/* <Menu.Divider className="dropdown-menu-divider"/> */}
        {/* // ! 福软的隐私策略和服务条款 */}
        {/* // TODO FOXIT 去除先 */}
        {/* <Menu.Item className="inline-item policy-wrapper">
          <a className="c-999 fs-10 lh-10" onClick={this.navToWithBlank.bind(this, privacyPolicyUrl, PRIVACY_POLICY)}>
            {intl.formatMessage({ id: 'user.policy' })}
          </a>
        </Menu.Item>
        <Menu.Item className="inline-item terms-wrapper">
          <a className="c-999 fs-10 lh-10" onClick={this.navToWithBlank.bind(this, termsOfServiceUrl, TERM_OF_SERVICE)}>            
            {intl.formatMessage({ id: 'user.terms' })}
          </a>
        </Menu.Item> */}
      </Menu>
    );

    return (
      <Dropdown overlay={menu} placement="bottomRight" trigger={['hover']}>
        <div className={`${userData && userData.identity === 'vip' ? 'fw-vip header-user' : 'header-user'}`}>
          {userData.figure ? (
            <div className={`${userData && userData.identity === 'vip' ? 'fw-vip-box' : ''}`}>
              <img src={userData.figure} alt="头像" className="icon-btn new_wrap_name fw_user-pigure" />
            </div>
          ) : (
            <i className="icon-btn new_wrap_name" />
          )}
        </div>
        {/* {userData.figure && <img src={userData.figure} alt="头像" className="icon-btn new_wrap_name" />} */}
      </Dropdown>
    );
  }
  showShareDlg = async () => {
    store.userStore.doSendGAEventByUser({ eventKey: SHARE_BUTTON, label: 'upper_right_area' });
    if (!window.__online__) {
      store.appStore.doNotifyErrors('offline');
      return;
    }
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      //TODO FOIXT 替换sso登录弹框
      store.loginNewStore.login();
      return false;
    }
    try {
      const checkAnnotFormPermission = await fileController.checkAnnotFormPermission();
      if (checkAnnotFormPermission === 0) {
        store.appStore.setGlobalMessage({ type: 'error', content: intl.get('collaboration.Dlg.noPermission') });
        return;
      }
      const doc = await pdfui.getCurrentPDFDoc();
      if (doc && doc.isPortfolio()) {
        store.appStore.setGlobalMessage({ type: 'error', content: intl.get('collaboration.Error.portfolioNotSupport') });
        return;
      }
      // 收集
      //   store.appStore.emitEvent(COLLECT_NPS_SURVEY);
      if (store.viewer.hasOpenFile) {
        // 显示共享弹框
        store.collaborationStore.changeShareDialogState(true);
      }
    } catch (error) {
      throw error;
    }
  };
  // showShareDlg = () => {
  //   store.userStore.doSendGAEventByUser({eventKey:SHARE_BUTTON, label:'upper_right_area'})

  //   // const { hasSignIn } = store.userStore;
  //   const hasSignIn = store.loginNewStore.isLogin
  //   if(!hasSignIn){
  //     //TODO FOIXT 替换sso登录弹框
  //     store.loginNewStore.login()
  //     //store.appStore.doUpdateSignInNotice({id:'Permission.SignIn'});
  //     return true;
  //   }
  //   if(store.viewer.hasOpenFile) store.collaborationStore.changeShareDialogState(true)
  // }
  showHomeStart = () => {
    const { onShowToSaveBeforeOpen } = store.appStore;
    pdfui.getRootComponent().then((root) => {
      root.querySelectorAll('@layer').forEach((dialog) => dialog.hide());
    });
    onShowToSaveBeforeOpen((isToSave) => {
      !isToSave && store.appStore.backToHomeStart();
    });
  };

  //! 保存本地按钮
  doSaveToLocalComputer = () => {
    if (!store.loginNewStore.isLogin) {
      store.loginNewStore.isShowLoginDlg();
      return;
    }
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    store.userStore.doSendGAEventByUser({ eventKey: SAVE_TO_LOCAL, label: 'upper_right_area' });
    store.saveFileNewStore.saveFile('downFile');

    // store.saveFileNewStore.saveFile("downFile")
    // const { saveToLocalComputer } = store.appStore
    // if (saveToLocalComputer) {
    //   // saveToLocalComputer();
    // }
  };
  /**
   * [doSaveToCloudComputer 打开云文档弹框]
   *
   * @return  {[type]}  [return description]
   */
  openCloudModal = () => {
    if (!store.loginNewStore.isLogin) {
      store.loginNewStore.isShowLoginDlg();
      return;
    }
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    store.docsStore.getDocsModalType('save');
    store.saveFileNewStore.setIsShowFwDocs(true);
  };
  onShowPrintDialog = async () => {
    if (!store.loginNewStore.isLogin) {
      store.loginNewStore.isShowLoginDlg();
      return;
    }
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    if (store.appStore.isCollaborationMode()) {
      store.userStore.doSendGAEvent({ eventKey: PRINT, label: 'review_mode_upper_right_area' });
    } else {
      store.userStore.doSendGAEventByUser({ eventKey: HOME_PRINT, label: 'upper_right_area' });
    }

    // 修改打印： 判断是否修改，修改过则先加封面保存，后打印；未修改，直接打印弹窗
    // 修改，完成一次打印后docModified的值会变为true，这里需要处理
    // 判断是否会员
    let identity = store.userNewStore.userData.identity;
    if (store.appStore.docModified) {
      if (identity === 'vip') {
        let printButton = await pdfui.getComponentByName('print-button');
        printButton.controller.handle();
      } else {
        store.saveFileNewStore.saveFileDialog('print');
      }
    } else {
      // ! 未做修改，直接弹窗
      let printButton = await pdfui.getComponentByName('print-button');
      printButton.controller.handle();
    }
  };

  doOpenLocalFile = () => {
    if (!window.pdfui) {
      let dom = document.getElementById('fwOpenLocalFile');
      dom.click();
    } else {
      store.userStore.doSendGAEventByUser({ eventKey: OPEN_FILE, label: 'upper_right_area' });
      const { openLocalFile } = store.appStore;
      store.loginNewStore.isShowLoginDlg();
      openLocalFile();
    }
  };
  doCreateNewPDF = () => {
    store.userStore.doSendGAEventByUser({ eventKey: CREATE_BLANK_PDF, label: 'upper_right_area' });
    const { onShowToSaveBeforeOpen } = store.appStore;
    const fn = () => {
      pdfui.pdfViewer.createNewDoc();
    };

    onShowToSaveBeforeOpen((isToSave) => {
      !isToSave && fn();
    });
  };
  bulrAnnot = (/*e*/) => {
    store.collaborationStore.unActiveAnnot();
  };

  // ! 添加撤销、恢复功能
  testUndo = () => {
    if (store.shareStore.shareDisabled || !store.userNewStore.userData.userId) {
      return;
    }
    let pdfui = window.pdfui;
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    store.loginNewStore.isShowLoginDlg();
    pdfui.callAddonAPI('UndoRedoAddon', 'undo');
  };
  testRedo = () => {
    if (store.shareStore.shareDisabled || !store.userNewStore.userData.userId) {
      return;
    }
    let pdfui = window.pdfui;
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    store.loginNewStore.isShowLoginDlg();
    pdfui.callAddonAPI('UndoRedoAddon', 'redo');
  };
  //! 插入图片
  insertImage = async () => {
    if (!store.loginNewStore.isLogin) {
      store.loginNewStore.isShowLoginDlg();
      return;
    }
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    let createImage = await pdfui.getComponentByName('create-image');
    createImage && createImage.controller.handle();
    // document.querySelector(".fv__ui-button[name$='create-image']").click()
  };
  //! 插入链接
  insertLink = async () => {
    if (!store.loginNewStore.isLogin) {
      store.loginNewStore.isShowLoginDlg();
      return;
    }
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    let createLink = await pdfui.getComponentByName('create-link');
    createLink && createLink.controller.handle();
    // document.querySelector(".fv__ui-button[name$='create-link']").click()
  };
  //! 插入附件
  insertFile = async () => {
    if (!store.loginNewStore.isLogin) {
      store.loginNewStore.isShowLoginDlg();
      return;
    }
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    // store.homePageStore.setOpenFileToolbarTab("comment-tab")
    let createFileattachment = await pdfui.getComponentByName('create-fileattachment');
    if (!createFileattachment) {
      let compByName = await window.pdfui.getComponentByName('comment-tab');
      compByName.active();
      createFileattachment = await pdfui.getComponentByName('create-fileattachment');
      createFileattachment.controller.handle();
    } else {
      createFileattachment.controller.handle();
    }
    // createFileattachment && createFileattachment.controller.handle()
  };
  //! 插入媒体文件
  insertMedia = async () => {
    if (!store.loginNewStore.isLogin) {
      store.loginNewStore.isShowLoginDlg();
      return;
    }
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    let createMultiMediaBtn = await pdfui.getComponentByName('multi-media-btn');
    createMultiMediaBtn && createMultiMediaBtn.controller.handle();
    // document.querySelector(".fx-ribbon-item[name$='multi-media-btn']").click()
  };
  //! 打开云文档
  doOpenDocs = async () => {
    console.log(isMacSsoNoIos);
    if (!store.loginNewStore.isLogin) {
      store.loginNewStore.isShowLoginDlg();
      return;
    }
    if (!window.pdfui) {
      let dom = document.getElementById('fwOpenDocsFile');
      dom.click();
      return;
    }
    if (store.appStore.docModified && store.appStore.hasOpenFile) {
      let doc = await pdfui.getCurrentPDFDoc();
      let fileName = '';
      if (doc && doc.metadata) {
        fileName = doc.metadata.FileName;
      }
      console.log('File.ToStopOpen 3');
      store.appStore.onShowWarningMessage(
        (isOk) => {
          if (isOk) {
            store.saveFileNewStore.saveFile('downFile', store.appStore.docModified);
            // store.appStore.doUpdateDocModified(false);
          } else {
            // 这里不关闭文件的话，会出现不开新文档可以跳过鉴权保存,所以选择否后关闭文件，会到主页
            store.appStore.backToHomeStart();
            this.goDocsPageOrIframe();
          }
        },
        { message: 'File.ToStopOpen', messageParams: { FileName: fileName }, cancel: 'No', ok: 'Yes', closable: true, customClose: true, iconType: 'alert' },
      );
    } else {
      this.goDocsPageOrIframe();
    }
  };
  // 跳转或打开云文档框
  goDocsPageOrIframe = () => {
    if ((isMacSsoNoIos || isSafari) && !store.docStore.macToDocPage) {
      store.saveFileNewStore.setIsShowFwDocsIframe(true);
    } else {
      store.saveFileNewStore.setIsShowFwDocsIframe(true);
    }
  };
  //! 打开云会议
  onMeeting = () => {
    document.querySelector('.meeting-btn').click();
  };
  // ! 打开远程文件
  onOpenUrl = async () => {
    // document.querySelector(".openUrlFileBtn").click()
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      store.loginNewStore.login();
      return true;
    }
    if (!window.pdfui) {
      let dom = document.getElementById('fwOpenUrlFile');
      dom.click();
      return;
    }
    if (store.appStore.docModified) {
      let doc = await pdfui.getCurrentPDFDoc();
      let fileName = '';
      if (doc && doc.metadata) {
        fileName = doc.metadata.FileName;
      }
      store.appStore.onShowWarningMessage(
        (isOk) => {
          if (isOk) {
            store.saveFileNewStore.saveFile('downFile', store.appStore.docModified);
            // store.appStore.doUpdateDocModified(false);
          } else {
            store.openUrlFileStore.openURLInputDialog(true);
          }
        },
        { message: 'File.ToStopOpen', messageParams: { FileName: fileName }, cancel: 'No', ok: 'Yes', closable: true, customClose: true, iconType: 'alert' },
      );
    } else {
      store.openUrlFileStore.openURLInputDialog(true);
    }
  };
  shareThis = () => {
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      store.loginNewStore.login();
      return true;
    }
    if (!store.viewer.hasOpenFile) {
      // 打开文档了没有？
      this.setState({ isShowNoPdfModal: true });
      return;
    }
    let { isBusinessUser } = store.userNewStore;
    let { shareUserType } = store.shareCollaborationStore;
    if (isBusinessUser || shareUserType) {
      document.querySelector('.fw-share-collaboration-btn').click();
      return;
    }
    document.querySelector('.share-btn').click();
  };
  alertMessage = () => {
    this.setState({ isShowNoFunction: true });
    // alert("功能开发中")
  };
  GetQueryString = () => {
    let url = document.location.toString();
    let arrUrl = url.split('?');
    let para = arrUrl[1];
    return para;
  };
  openVip = (type) => {
    if (type) {
      // 企业开通
      if (this.GetQueryString()) {
        window.open(`https://vip.foxitsoftware.cn/pay/member.html?${this.GetQueryString()}`);
      } else {
        window.open(`https://vip.foxitsoftware.cn/pay/member.html`);
      }
    } else {
      window.open('https://www.foxitcloud.cn/pay/cloudEditPay');
    }
  };
  closeNoVipSpaceDialog = () => {
    store.docsStore.isShowNoVipSpaceDialog = false;
    store.docsStore.isShowVipSpaceDialog = false;
    store.docsStore.isShowMoreSpaceDialog = false;
  };
  /**
   * 保存至云办公
   */
  saveFileOffice = async () => {
    let res = await store.office.fileToBlob();
    if (res.ret === 0) {
      localStorage.setItem('saveRegister', true);
      store.office.getIsShowSaveSuccess(true);
      window.open(`https://www.foxitcloud.cn/work/interviewEdit?id=${res.data.id}&type=register&templateId=0`);
    }
  };
  // 开通会员跳转
  payMember = () => {
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      store.loginNewStore.login();
      return;
    } else {
      let payOrigin = isMacSsoNoIos || isSafari ? 'edit.foxitcloud.cn/pay/edit/' : 'www.foxitcloud.cn/pay/edit/';
      let url = `https://${payOrigin}?from=startpage${location.search.trim().slice(1) && '&'}${location.search.trim().slice(1)}`;
      if (window.location.search.includes('from=pdf365/?refer=bd')) {
        url = `https://www.foxitcloud.cn/pay/edit/baidu365/${location.search.trim().slice(1) && '?'}${location.search.trim().slice(1)}`;
      }
      // TODO FOXIT 漏洞优化window.open方法；
      // window.open(url)
      const newWindow = window.open(url);
      newWindow.opener = null;
    }
  };
  // changeIam = () => {
  //   store.loginNewStore.IAMToken = "123123"
  // }

  render() {
    //userInfo
    const { isAdmin } = store.userStore;
    const { hasOpenFile } = store.viewer;
    let { userData, isBusinessUser } = store.userNewStore;
    const { isCustomLogo, headerType, isOnPremiseDeployMode } = store.appStore;
    const { historyParams } = store.historyStore;
    const { isLogin } = store.loginNewStore;
    // const {fileName} = store.docStore.docInfo
    const { isShowNoVipSpaceDialog, isShowVipSpaceDialog, isShowMoreSpaceDialog } = store.docsStore;
    const { isShowNoPdfModal, isShowNoFunction } = this.state;
    let isHideUserElements = this.isHideUserElements(historyParams);

    let isPersonCollaboration = location.search.includes('reviewSessionID');

    const { shareUserType, noCollaborationToShare, isOpenOtherShare } = store.shareCollaborationStore;
    const { shareReviewData } = store.collaborationStore;

    console.log('headerType:' + headerType);
    // let isShowSubscribe = !isOnPremiseDeployMode && !isSurveyList && hasSignIn && !roleInfo && subscriptionState && !isActive && !isDashboardTrial;
    if (isCustomLogo) {
      logoTitle = store.appStore.appTitle;
      if (store.appStore.appTitle && store.appStore.appTitle.length > 20) {
        logoTitle = store.appStore.appTitle.substr(0, 20) + '...';
      }
    }
    const menus = (
      <Menu className="fw_logo-menu">
        <Menu.Item onClick={this.doOpenLocalFile}>
          <span>打开本地文件</span>
        </Menu.Item>
        <Menu.Item onClick={this.doOpenDocs}>
          <span>打开云文档</span>
        </Menu.Item>
        <Menu.Item onClick={this.onOpenUrl}>
          <span>打开远程文件</span>
        </Menu.Item>
        <Menu.Divider className="dropdown-menu-divider" />
        <Menu.Item onClick={this.doSaveToLocalComputer}>
          <span>保存</span>
        </Menu.Item>
        <SubMenu title="另存为">
          <Menu.Item className="fw_item" onClick={this.doSaveToLocalComputer}>
            <span>另存到本地</span>
          </Menu.Item>
          <Menu.Item className="fw_item" onClick={this.openCloudModal}>
            <span>另存到云文档</span>
          </Menu.Item>
        </SubMenu>
        <Menu.Divider className="dropdown-menu-divider" />
        <Menu.Item onClick={this.shareThis} disabled={!hasOpenFile}>
          <span>分享</span>
        </Menu.Item>
        <Menu.Divider className="dropdown-menu-divider" />
        <SubMenu title="插入">
          <Menu.Item className="fw_item" onClick={this.insertImage}>
            <span>插入图片</span>
          </Menu.Item>
          <Menu.Item className="fw_item" onClick={this.insertFile}>
            <span>插入附件</span>
          </Menu.Item>
          <Menu.Item className="fw_item" onClick={this.insertLink}>
            <span>插入链接</span>
          </Menu.Item>
          <Menu.Item className="fw_item" onClick={this.insertMedia}>
            <span>插入媒体文件</span>
          </Menu.Item>
        </SubMenu>
        {/* <Menu.Item onClick={this.alertMessage}>
          <span>插入</span>
        </Menu.Item> */}
        <Menu.Item onClick={this.onShowPrintDialog}>
          <span>打印</span>
        </Menu.Item>
      </Menu>
    );
    const { shareDisabled } = store.shareStore;
    const { isShowSaveBtn } = store.office;
    const { isShowHomeStart } = store.appStore;
    return (
      <div className={'header_container new_header'}>
        <Row className={'h-100z p-r'} type="flex" align="middle" justify="space-between">
          {/* TODO FOXIT 测试下撤销和恢复功能，后续更新 */}
          {/* TODO FOXIT UI开始 */}
          <Col className={'height_28'} style={{ display: 'inline-block', zIndex: 10 }} span={6}>
            <div className="fw_header-left">
              {utils.util.getQueryString('agent') !== 'sjmkd' && (
                <div className="fw_header-logo">
                  <a href="/" target="_blank" aria-current="page">
                    <img src={require('../../assets/fw_cloud_editor/header/headerLogo.png')} alt="" />
                    {/* {!hasOpenFile && (<span>福昕在线编辑</span>)} */}
                  </a>
                </div>
              )}
              {/* {!hasOpenFile && ( <div className="headerTagBox">
                  <img src={require('../../assets/fw_cloud_editor/header/headerTag.png')} alt="收藏福昕在线编辑" />
                  <p>拖动logo到书签栏，立即收藏福昕在线编辑</p>
                </div>)} */}
              {isOpenOtherShare && (
                <div className="fw_header-other-share-info">
                  {shareReviewData.userName} 共享的 &gt; {shareReviewData.docName}
                  {/* {isOpenOtherShare?`${shareReviewData.userName} `:"我"}共享的 &gt; {shareReviewData.docName} */}
                </div>
              )}
              {!isOpenOtherShare && (
                <>
                  <div className="fw_header-logo-box" data-agl-cvt="6">
                    <Dropdown overlay={menus} placement="bottomLeft" trigger={['click']}>
                      <i className="fw_header-logo"></i>
                    </Dropdown>
                  </div>
                  <i className="fw_header-logo-line"></i>
                  <Tooltip placement="bottom" title={'打开pdf'}>
                    <button
                      data-agl-cvt="6"
                      className="open-file-btn icon-btn cursor-pointer"
                      style={{ display: 'inline-block' }}
                      onClick={this.doOpenLocalFile}
                    />
                  </Tooltip>
                  {hasOpenFile && (
                    <Tooltip placement="bottom" title={'保存'}>
                      <button className="save-new-btn icon-btn cursor-pointer" onClick={this.doSaveToLocalComputer} />
                    </Tooltip>
                  )}
                  {hasOpenFile && (
                    <Tooltip placement="bottom" title={'打印'}>
                      <button className="print-new-btn icon-btn cursor-pointer" onClick={this.onShowPrintDialog} />
                    </Tooltip>
                  )}
                  {hasOpenFile && (
                    <Tooltip placement="bottom" title={'撤销'}>
                      <button className={`undo-btn icon-btn cursor-pointer ${shareDisabled && 'shareDisabledUndoRedo'}`} onClick={this.testUndo} />
                    </Tooltip>
                  )}
                  {hasOpenFile && (
                    <Tooltip placement="bottom" title={'恢复'}>
                      <button className={`redo-btn icon-btn cursor-pointer ${shareDisabled && 'shareDisabledUndoRedo'}`} onClick={this.testRedo} />
                    </Tooltip>
                  )}
                </>
              )}
            </div>
          </Col>
          {isShowHomeStart && (
            <Col className="fw_fake-tabs" span={10}>
              <ul className="fake-tab-list">
                <li className="fake-tab-item">文件</li>
                <li className="fake-tab-item active">主页</li>
                <li className="fake-tab-item">转换</li>
                <li className="fake-tab-item">编辑</li>
                <li className="fake-tab-item">页面管理</li>
                <li className="fake-tab-item">注释</li>
                <li className="fake-tab-item">视图</li>
                <li className="fake-tab-item">表单</li>
                <li className="fake-tab-item">保护</li>
                <li className="fake-tab-item">帮助</li>
              </ul>
            </Col>
          )}
          <Col className={isHideUserElements ? 'd-n' : 'height_26' + ' header_right'} span={headerType === COLLABORATION_HEADER ? 16 : 10}>
            {isShowSaveBtn && !isShowHomeStart && (
              <button className="saveFileOffice" onClick={this.saveFileOffice}>
                保存登记表
              </button>
            )}
            {/* 添加 开通会员按钮 */}
            {/* 共享协作 -- 按钮 */}
            {/* {hasOpenFile && !isOnPremiseDeployMode && headerType===COMMON_HEADER && userData && !userData.companyName && <Button className="share-collaboration-btn c-ok" onClick={this.showShareDlg} disabled={this.state.isProtectedView}>{intl.get('HeaderContainer.ShareBtn')}</Button>} */}
            {/* 共享协作二期 -- toolbar头部 */}
            {headerType === COLLABORATION_HEADER && userData && hasOpenFile && (
              <div className="collaboration-header-wrapper">
                <CollaborationHeader printBtn={this.onShowPrintDialog} />
              </div>
            )}
            {/* 分享接口 */}
            {/* {userData && !userData.companyName && <ShareBtn />} */}
            {/* 分享协同区分个人账户，企业账户，*/}
            {/* 
                企业账户：  分享协同功能合并整合，
                  1、共享按钮改名分享，取消分享图标；
                  2、共享后进入现在分享的流程，未生成链接进入初始创建页，已生成进去分享信息页（可修改信息），添加全局标识——企业分享
                  3、点击创建并分享后就进入当前用户及进入协同操作状态
              */}
            {/* 
                个人账户： 保留现有功能，分享、协同功能单独入口进入，
                  1、原逻辑不变，加入全局判断，分享链接来源于企业用户还是个人用户
                  2、共享后进入现在分享的流程，未生成链接进入初始创建页，已生成进去分享信息页（可修改信息） 
              */}
            {/* 
                判断：1、是否分享：非分享，判断登入的用户类型——企业或个人？
                                  已分享，判断进入分享的链接类型：个人链接显示现有逻辑，企业信息，显示新版交互
                      2、未登录，且非分享链接，初始化页面不在显示分享或共享按钮图标，避免登录后未打开文档显示不同。
              */}

            {/* 个人账户 */}
            {isLogin && hasOpenFile && !isBusinessUser && hasOpenFile && !isOnPremiseDeployMode && headerType === COMMON_HEADER && (
              <Button className="share-collaboration-btn c-ok" onClick={this.showShareDlg} disabled={this.state.isProtectedView}>
                {intl.get('HeaderContainer.ShareBtn')}
              </Button>
            )}
            {isLogin && hasOpenFile && !isBusinessUser && !shareUserType && <ShareBtn />}
            {/* 企业账户 结合原分享，使用新的组件——shareCollaborationbtn */}
            {/* 企业用户打开分享添加判断——分享链接带 reviewSessionID 参数，则为个人用户分享，显示普通分享按钮 */}
            {
              isLogin && hasOpenFile && (isBusinessUser || shareUserType) && !isPersonCollaboration && <ShareCollaborationbtn />
              // isLogin && isBusinessUser && hasOpenFile && !isOnPremiseDeployMode && <ShareCollaborationbtn />
            }
            {isLogin && (isBusinessUser || shareUserType) && !isPersonCollaboration && hasOpenFile && noCollaborationToShare && <ShareBtn />}

            {/* 添加一个云会议按钮 */}
            {/* { hasOpenFile && <Meeting />} */}
            <Meeting />
            <DownloadApp />
            {isShowHomeStart && (
              <button className="saveFileOffice payMember" onClick={this.payMember}>
                {userData && userData.identity === 'vip' ? '立即续费' : '开通会员'}
              </button>
            )}
            {!userData && (
              <span className="fw_login-btn" data-agl-cvt="6" onClick={this.onLoginIn}>
                登录
              </span>
            )}
            {userData && this.showUserMenu(userData, isAdmin)}

            {isShowNoPdfModal && (
              <Modal
                width={450}
                closable={true}
                title="福昕云编辑"
                visible={isShowNoPdfModal}
                className="noPdf"
                footer={[
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      this.setState({ isShowNoPdfModal: false });
                    }}>
                    确定
                  </Button>,
                ]}
                onCancel={() => {
                  this.setState({ isShowNoPdfModal: false });
                }}>
                <img src={require('../../assets/fw_cloud_editor/main/warning.png')} alt="提示" /> <br />
                <p>请先打开文档</p>
              </Modal>
            )}
            {isShowNoFunction && (
              <Modal
                width={450}
                closable={true}
                title="福昕云编辑"
                visible={isShowNoFunction}
                className="noPdf"
                footer={[
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      this.setState({ isShowNoFunction: false });
                    }}>
                    确定
                  </Button>,
                ]}
                onCancel={() => {
                  this.setState({ isShowNoFunction: false });
                }}>
                <img src={require('../../assets/fw_cloud_editor/main/warning.png')} alt="提示" /> <br />
                <p>功能开发中</p>
              </Modal>
            )}
            {isShowNoVipSpaceDialog && (
              <Modal
                width={450}
                closable={true}
                title="福昕云编辑"
                visible={isShowNoVipSpaceDialog}
                className="noPdf"
                footer={[
                  <Button key="submit" type="primary" onClick={this.openVip}>
                    立即开通
                  </Button>,
                  <Button key="submitCancel" onClick={this.closeNoVipSpaceDialog}>
                    取消
                  </Button>,
                ]}
                onCancel={this.closeNoVipSpaceDialog}>
                <img src={require('../../assets/fw_cloud_editor/main/warning.png')} alt="提示" /> <br />
                <p>当前空间容量不足，开通福昕会员，可享受10G超大空间！</p>
              </Modal>
            )}
            {isShowVipSpaceDialog && (
              <Modal
                width={450}
                closable={true}
                title="福昕云编辑"
                visible={isShowVipSpaceDialog}
                className="noPdf"
                footer={[
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      this.openVip(true);
                    }}>
                    立即开通
                  </Button>,
                  <Button key="submitCancel" onClick={this.closeNoVipSpaceDialog}>
                    取消
                  </Button>,
                ]}
                onCancel={this.closeNoVipSpaceDialog}>
                <img src={require('../../assets/fw_cloud_editor/main/warning.png')} alt="提示" /> <br />
                <p>当前空间容量不足，开通福昕会员，可享受10G超大空间!</p>
              </Modal>
            )}
            {isShowMoreSpaceDialog && (
              <Modal
                width={450}
                closable={true}
                title="福昕云编辑"
                visible={isShowMoreSpaceDialog}
                className="noPdf ShowMoreSpaceDialog"
                footer={[
                  <Button key="submit" type="primary" onClick={this.closeNoVipSpaceDialog}>
                    关闭
                  </Button>,
                ]}
                onCancel={this.closeNoVipSpaceDialog}>
                <img src={require('../../assets/fw_cloud_editor/main/warning.png')} alt="提示" /> <br />
                <p>当前空间不足，建议删除一部分文件</p>
              </Modal>
            )}
            {/* </div> */}
          </Col>
        </Row>
      </div>
    );
  }
}

export default newHeader;
